<template>
    <router-view />
</template>

<script>  
import Cookies from 'js-cookie';

export default {
    components: {},
    data() {
        return {

        }
    },
    created() {
        // var token = localStorage.getItem("token");
        // if (token) {
        //     Cookies.set('token', token);
        // } else {
        //     Cookies.remove('token');
        // }

        this.$store.dispatch('loadUserInfo');
        this.$store.dispatch('loadCategoryList');
    },

};
</script>
<style lang="scss">
#app {
}
</style>
